import { render, staticRenderFns } from "./modal-punch.vue?vue&type=template&id=46dee842&"
import script from "./modal-punch.vue?vue&type=script&lang=js&"
export * from "./modal-punch.vue?vue&type=script&lang=js&"
import style0 from "./modal-punch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports